import pb from '../lib/pocketbase.js';

// Obtener archivos de un drop específico paginados
export async function getEgresoDropFiles(egresoDropId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDropFiles').getList(page, perPage, {
      filter: `egresoDrop = "${egresoDropId}"`,
      $autoCancel: false
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoDropFiles:", error);
    throw new Error("Error al obtener los archivos del drop");
  }
}

// Obtener archivos de todos los drops de un egreso
export async function getEgresoDropFilesByEgreso(egresoCabId, page = 1, perPage = 100) {
  try {
    // First get all drops for this egreso
    const dropsResponse = await pb.collection('egresoDrop').getList(1, 100, {
      filter: `egresoCab = "${egresoCabId}"`,
      $autoCancel: false
    });
    
    const dropIds = dropsResponse.items.map(drop => drop.id);
    
    if (dropIds.length === 0) {
      return {
        items: [],
        totalItems: 0,
        page: 1,
      };
    }
    
    // Then get all files for these drops
    const filterString = dropIds.map(id => `egresoDrop = "${id}"`).join(' || ');
    const response = await pb.collection('egresoDropFiles').getList(page, perPage, {
      filter: `(${filterString})`,
      $autoCancel: false,
      expand: "egresoDrop"
    });
    
    return {
      items: response.items,
      totalItems: response.totalItems,
      page: response.currentPage,
    };
  } catch (error) {
    console.error("Error fetching egresoDropFiles by egreso:", error);
    throw new Error("Error al obtener los archivos de los drops");
  }
}

// Subir un nuevo archivo para un drop
export async function uploadEgresoDropFile(egresoDropFile) {
  try {
    const response = await pb.collection('egresoDropFiles').create(egresoDropFile);
    return response;
  } catch (error) {
    console.error("Error uploading egresoDropFile:", error);
    throw new Error("Error al subir el archivo del drop");
  }
}

// Actualizar un archivo de drop
export async function updateEgresoDropFile(id, egresoDropFile) {
  try {
    const response = await pb.collection('egresoDropFiles').update(id, egresoDropFile);
    return response;
  } catch (error) {
    console.error("Error updating egresoDropFile:", error);
    throw new Error("Error al actualizar el archivo del drop");
  }
}

// Eliminar un archivo de drop
export async function deleteEgresoDropFile(id) {
  try {
    await pb.collection('egresoDropFiles').delete(id);
  } catch (error) {
    console.error("Error deleting egresoDropFile:", error);
    throw new Error("Error al eliminar el archivo del drop");
  }
}

// Buscar archivos de drop por nombre con paginación
export async function searchEgresoDropFiles(query, egresoDropId, page = 1, perPage = 10) {
  try {
    const response = await pb.collection('egresoDropFiles').getList(page, perPage, {
      filter: `file ~ "${query}" && egresoDrop = "${egresoDropId}"`,
    });
    return {
      items: response.items,
      totalItems: response.totalItems,
      currentPage: response.currentPage,
    };
  } catch (error) {
    console.error("Error searching egresoDropFiles:", error);
    throw new Error("Error al buscar los archivos del drop");
  }
} 